// تسجيل Service Worker مع إشعار المستخدم عند توفّر تحديث.

export function registerServiceWorker({ onUpdateAvailable } = {}) {
  if (!('serviceWorker' in navigator)) return;

  // لا نسجّله في التطوير حتى لا يخدم ملفات مخزّنة بدل التعديلات الحيّة
  if (import.meta.env.DEV) return;

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', { scope: '/' });

      registration.addEventListener('updatefound', () => {
        const installing = registration.installing;
        if (!installing) return;

        installing.addEventListener('statechange', () => {
          // نسخة جديدة جاهزة وهناك نسخة قديمة تعمل حالياً
          if (installing.state === 'installed' && navigator.serviceWorker.controller) {
            onUpdateAvailable?.(() => {
              installing.postMessage('SKIP_WAITING');
              window.location.reload();
            });
          }
        });
      });
    } catch (err) {
      console.warn('تعذر تسجيل Service Worker:', err);
    }
  });
}
